// extracted by mini-css-extract-plugin
export default {"place-form":"UpdatePlace_place-form__ZNbiB"};